
import React from 'react';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

const CloseButton = ({
    onClick,
    title
}) => {

    const classNames = mergeStyleSets({
        closeButton: {
            width: 16,
            padding: 4,
            cursor: 'pointer',
            color: '#aaaaaa',
            selectors: {
                ':hover': {
                    color: '#000000'
                }
            }
        },
        closeButtonIcon: {
            fontSize: 16,
            height: 16,
            width: 16,
            margin: '0 0 0 0'
        }
    });

    const handleCloseClick = () => {
        if (onClick) {
            onClick();
        }
    }

    return (
        <div className={classNames.closeButton} onClick={handleCloseClick}>
            <FontIcon
                iconName="Cancel"
                className={classNames.closeButtonIcon}
                title={title || 'Zavřít'}
            />
        </div>
    );
}

export default CloseButton;
